import { apiErrorResponse } from "@/utils/apiErrors";
import { goSolidApi } from "./useGoSolidApi";

/** The `error_type` both CoreSignal endpoints answer with (a 503) while CoreSignal is down, overloaded or too slow. */
const COMPANY_SEARCH_UNAVAILABLE = "COMPANY_SEARCH_UNAVAILABLE";

export interface CoreSignalCompany {
  id: number;
  name: string;
  website: string | null;
  industry: string | null;
  description: string | null;
  founded: number | null;
  size: string | null;
  type: string | null;
  country: string | null;
  locality: string | null;
  region: string | null;
  street_address: string | null;
  postal_code: string | null;
  professional_network_url: string | null;
}

export interface CoreSignalCompanyDetails {
  name: string;
  registry_code: string | null;
  address: string | null;
  vat: string | null;
  country: string | null;
  website: string | null;
}

export async function fetchCoreSignalCompanyDetails(
  companyId: number
): Promise<CoreSignalCompanyDetails | null> {
  const response = await goSolidApi.get(
    `/api/utils/coresignal/companies/${companyId}`
  );
  return response.data;
}

/**
 * Whether a failed CoreSignal call means company search is unavailable for now.
 *
 * That is an outage the user works around by entering their company by hand, not a bug: the UI
 * says so in place, rather than handing it to `globalErrorHandler`.
 */
export function isCompanySearchUnavailable(error: unknown): boolean {
  return (
    apiErrorResponse(error)?.data?.error_type === COMPANY_SEARCH_UNAVAILABLE
  );
}
